export const DIMENSIONS = Object.freeze({
  width: 326,
  height: 650,
  gutter: 20,

  doubleTextWidth: 200,
  singleTextHeight: 100,
});
